export default process.env.GATSBY_IS_MOBILE === "true";
